/* eslint-disable object-curly-newline */
import shoppingCartApi from '@/api/shopping-cart';
import { storeActionCommit } from '@/utils/common-utils';

export default {
  createShoppingCart({ commit }, { shoppingCart, errorManagementType }) {
    return shoppingCartApi.createShoppingCart(shoppingCart, errorManagementType)
      .then((response) => {
        const lockVerion = 1;
        localStorage.setItem('x-cart', response.id);

        shoppingCart.id = response.id;
        shoppingCart.lockVerion = lockVerion;
        return storeActionCommit(commit, 'setShoppingCart')(shoppingCart);
      });
  },

  fetchShoppingCart({ commit }, { id, idType, errorManagementType }) {
    idType = idType == null ? 'id' : idType;

    return shoppingCartApi.fetchShoppingCart(id, idType, errorManagementType)
      .then((shoppingCart) => {
        localStorage.setItem('x-cart', shoppingCart.account.id);
        return storeActionCommit(commit, 'setShoppingCart')(shoppingCart);
      });
  },
  updateShoppingCart({ commit }, { id, shoppingCart, errorManagementType }) {
    return shoppingCartApi.updateShoppingCart(id, shoppingCart, errorManagementType)
      .then(storeActionCommit(commit, 'setShoppingCart')(shoppingCart))
      .then(storeActionCommit(commit, 'setCartLockVersion')(shoppingCart.lockVersion + 1));
  },

  addProductToShoppingCart({ commit }, { id, product, errorManagementType }) {
    return shoppingCartApi.addProductToShoppingCart(id, product, errorManagementType)
      .then(storeActionCommit(commit, 'addProduct')(product));
  },

  emptyShoppingCart({ commit }) {
    // localStorage.removeItem('x-cart');
    return storeActionCommit(commit, 'setShoppingCart')(null);
  },

};
